/**
 * third-party-idle-loader.js (P13)
 *
 * Defers non-critical third-party scripts until after the first user
 * interaction, or until the browser is idle (requestIdleCallback with a
 * setTimeout fallback), so they never compete with the initial render.
 *
 * Currently the only deferred script is Varify.io — its account id
 * (window.varify.iid) is set inline in layout/theme.liquid before this
 * file loads. Add further entries to the list only for scripts that are
 * genuinely interaction/idle-safe; consent-governed scripts belong to the
 * CMP or the app embeds, never here.
 *
 * Live parity: same trigger set and timing as the live theme's idle
 * loader (theme.liquid:89), renamed per the naming rule.
 */
(function () {
  let loaded = false;

  const scripts = [
    // Varify.io A/B testing - window.varify.iid is set inline before this loads
    { src: 'https://app.varify.io/varify.js', async: 'true' },
  ];

  function loadScript(src, attrs) {
    const script = document.createElement('script');
    script.src = src;
    Object.entries(attrs || {}).forEach(function (entry) {
      script.setAttribute(entry[0], entry[1]);
    });
    document.head.appendChild(script);
  }

  function loadAll() {
    if (loaded) return;
    loaded = true;
    scripts.forEach(function (item) {
      const attrs = Object.assign({}, item);
      delete attrs.src;
      loadScript(item.src, attrs);
    });
  }

  ['scroll', 'click', 'keydown', 'touchstart'].forEach(function (evt) {
    window.addEventListener(evt, loadAll, { once: true, passive: true });
  });

  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadAll);
  } else {
    setTimeout(loadAll, 3000);
  }
})();
